import { useLanguage } from "@/i18n";
import { extra } from "@/i18n_extra";

const extra3 = {
  en: {
    stats: {
      label: "By the numbers",
      items: [
        { value: 500, suffix: "+", label: "Windshields serviced" },
        { value: 15, suffix: " min", label: "Average quote response" },
        { value: 0, prefix: "$", label: "Deductible with insurance" },
        { value: 4.9, decimals: 1, suffix: "★", label: "Google rating" },
      ],
    },
    how: {
      label: "How it works",
      title: "Three steps. Zero stress.",
      steps: [
        { t: "Snap & send", d: "A photo of the damage plus your plate or VIN — that's all we need." },
        { t: "Get a firm price", d: "A real specialist replies in ~15 minutes during business hours." },
        { t: "We fix it", d: "At our Peabody shop or at your curb — most jobs done the same day." },
      ],
    },
    warranty: {
      label: "Our promise",
      title: "Lifetime warranty.",
      sub: "Every job is guaranteed for as long as you own the vehicle.",
      points: ["Workmanship guaranteed for life", "Water-leak free, guaranteed", "OEM-quality materials only"],
    },
    carriersLabel: "We work directly with every major insurer",
    exit: {
      title: "Leaving so soon?",
      sub: "Your quote takes about 15 minutes. A crack won't wait — but we'll make it easy.",
      whats: "Get my quote on WhatsApp",
      quote: "Start instant quote",
      dismiss: "Maybe later",
    },
    team: {
      label: "The crew",
      title: "Real people. Real craft.",
      sub: "The technicians behind ClearRoute — uniformed, certified and obsessed with the details.",
      roles: ["Master Technician", "Glass Specialist"],
    },
    beforeAfter: { label: "See the difference", title: "Drag it. Watch it disappear.", before: "Before", after: "After", cases: ["Spiderweb crack", "Highway crack"] },
    blogSection: { label: "From the blog", title: "Glass wisdom, plain English.", readMore: "Read", min: "min read" },
  },
  pt: {
    stats: {
      label: "Em números",
      items: [
        { value: 500, suffix: "+", label: "Para-brisas atendidos" },
        { value: 15, suffix: " min", label: "Resposta média de orçamento" },
        { value: 0, prefix: "$", label: "Franquia com seguro" },
        { value: 4.9, decimals: 1, suffix: "★", label: "Nota no Google" },
      ],
    },
    how: {
      label: "Como funciona",
      title: "Três passos. Zero estresse.",
      steps: [
        { t: "Fotografe e envie", d: "Uma foto do dano + placa ou VIN — é só isso que precisamos." },
        { t: "Receba preço fechado", d: "Um especialista de verdade responde em ~15 min no horário comercial." },
        { t: "A gente resolve", d: "Na loja em Peabody ou na sua rua — a maioria no mesmo dia." },
      ],
    },
    warranty: {
      label: "Nossa promessa",
      title: "Garantia vitalícia.",
      sub: "Todo trabalho garantido enquanto o veículo for seu.",
      points: ["Mão de obra garantida para sempre", "Zero vazamento, garantido", "Só materiais qualidade OEM"],
    },
    carriersLabel: "Trabalhamos direto com todas as grandes seguradoras",
    exit: {
      title: "Já vai embora?",
      sub: "Seu orçamento leva uns 15 minutos. A trinca não espera — mas a gente facilita.",
      whats: "Orçamento pelo WhatsApp",
      quote: "Orçamento instantâneo",
      dismiss: "Talvez depois",
    },
    team: {
      label: "A equipe",
      title: "Gente de verdade. Ofício de verdade.",
      sub: "Os técnicos por trás da ClearRoute — uniformizados, certificados e obcecados pelos detalhes.",
      roles: ["Técnico Master", "Especialista em Vidros"],
    },
    beforeAfter: { label: "Veja a diferença", title: "Arraste. Veja sumir.", before: "Antes", after: "Depois", cases: ["Trinca em teia", "Trinca na estrada"] },
    blogSection: { label: "Do blog", title: "Sabedoria de vidro, sem enrolação.", readMore: "Ler", min: "min de leitura" },
  },
  es: {
    stats: {
      label: "En números",
      items: [
        { value: 500, suffix: "+", label: "Parabrisas atendidos" },
        { value: 15, suffix: " min", label: "Respuesta media de cotización" },
        { value: 0, prefix: "$", label: "Deducible con seguro" },
        { value: 4.9, decimals: 1, suffix: "★", label: "Nota en Google" },
      ],
    },
    how: {
      label: "Cómo funciona",
      title: "Tres pasos. Cero estrés.",
      steps: [
        { t: "Fotografía y envía", d: "Una foto del daño + placa o VIN — es todo lo que necesitamos." },
        { t: "Recibe precio firme", d: "Un especialista real responde en ~15 min en horario laboral." },
        { t: "Lo arreglamos", d: "En nuestra tienda de Peabody o en tu calle — casi siempre el mismo día." },
      ],
    },
    warranty: {
      label: "Nuestra promesa",
      title: "Garantía de por vida.",
      sub: "Cada trabajo garantizado mientras el vehículo sea tuyo.",
      points: ["Mano de obra garantizada de por vida", "Cero filtraciones, garantizado", "Solo materiales calidad OEM"],
    },
    carriersLabel: "Trabajamos directo con todas las grandes aseguradoras",
    exit: {
      title: "¿Ya te vas?",
      sub: "Tu cotización toma unos 15 minutos. La grieta no espera — pero lo hacemos fácil.",
      whats: "Cotización por WhatsApp",
      quote: "Cotización instantánea",
      dismiss: "Quizás después",
    },
    team: {
      label: "El equipo",
      title: "Gente real. Oficio real.",
      sub: "Los técnicos detrás de ClearRoute — uniformados, certificados y obsesionados con los detalles.",
      roles: ["Técnico Master", "Especialista en Vidrios"],
    },
    beforeAfter: { label: "Mira la diferencia", title: "Arrastra. Mírala desaparecer.", before: "Antes", after: "Después", cases: ["Grieta en telaraña", "Grieta en carretera"] },
    blogSection: { label: "Del blog", title: "Sabiduría de vidrios, sin rodeos.", readMore: "Leer", min: "min de lectura" },
  },
};

export const useT = () => {
  const { t, lang } = useLanguage();
  return { ...t, ...(extra[lang] || extra.en), ...(extra3[lang] || extra3.en) };
};
